import { useParams } from "react-router-dom";
import "../pages/PatientDetails.scss";
import { useEffect, useRef, useState } from "react";
import badAccuracy from "../assets/images/accuracy3.svg";
import stepCount from "../assets/images/stepCount.png";
import stepTime from "../assets/images/stepTime.png";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import CSVExportButton from "./CSVGenerator";
import PDFExportButton from "./PDFExportButton";
const SessionResult = ({
  sessionType,
  sessionData,
  selectedDuration,
  leftForceArray,
  rightForceArray,
  leftWaveform,
  rightWaveform,
  calculateAverage,
  selectedTarget,
  stepCounts,
  stepTimes,
  accuracy,
}) => {
  const [avgStepTime, setAvgStepTime] = useState(0);
  const hasSessionResults =
    leftForceArray.length > 0 ||
    rightForceArray.length > 0 ||
    leftWaveform.length > 0 ||
    rightWaveform.length > 0;

  useEffect(() => {
    const sum = stepTimes.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    if (stepCounts > 0) {
      setAvgStepTime(sum / stepCounts);
    }
  }, []);
  const stepForce = useRef();
  const forceProfile = useRef();
  const averageForce = useRef();
  const otherMetrics = useRef();

  if (!hasSessionResults) {
    return (
      <div className="pageContainer">
        <div className="h3" style={{ margin: "2rem" }}>
          No session results are available yet.
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="row" style={{ justifyContent: "flex-end" }}>
        {/* <CSVExportButton type="result" sessionData={sessionData} /> */}

        <PDFExportButton
          chartRefs={[stepForce, forceProfile, averageForce, otherMetrics]}
          sessionData={sessionData}
        />
      </div>
      <div
        className="grid"
        style={{
          gridTemplateColumns: "0.4fr 0.4fr 0.2fr",
          columnGap: "1rem",
          rowGap: "1rem",
          padding: "1rem",
          marginLeft: "1.5rem",
        }}
      >
        <div ref={stepForce} className="resultGrid">
          <div style={{ padding: "0 0.5rem 2rem 0.5rem" }}>
            {" "}
            <div className="h2">Step-By-Step Force</div>
            <div className="b2">Force vs Time</div>
          </div>
          <div>
            <LineChart
              labels={selectedDuration * 60}
              leftData={leftForceArray}
              rightData={rightForceArray}
              tension={0.25}
            />
          </div>
        </div>
        <div ref={forceProfile} className="resultGrid">
          <div style={{ padding: "0 0.5rem 2rem 0.5rem" }}>
            {" "}
            <div className="h2">Force Profile</div>
            <div className="b2">Force vs Stance phase</div>
          </div>
          <div>
            <LineChart
              labels={selectedDuration * 60}
              leftData={leftWaveform} //change this
              rightData={rightWaveform} //change this
              tension="1"
            />
          </div>
        </div>
        <div className=""></div>
        <div ref={averageForce} className="resultGrid">
          <div className="h2">Average Force</div>
          <div>
            <BarChart
              leftForce={calculateAverage(leftForceArray)}
              rightForce={calculateAverage(rightForceArray)}
              targetForce={selectedTarget}
              displayTargetForce={true}
            />
          </div>
        </div>

        {(sessionType === "Detect" || sessionType === "Treat") && (
          <>
            <div className="resultGrid">
              <div style={{ padding: "0 0.5rem 2rem 0.5rem" }} className="h2">
                Session Summary
              </div>
              <div className="b2">
                Difference between target values and average peak force per leg
              </div>
              <div
                className="row space-between"
                style={{ alignItems: "center", marginTop: "2rem" }}
              >
                <div>Overground Left</div>
                <div>{(112 - calculateAverage(leftWaveform)).toFixed(2)}</div>
              </div>
              <div
                className="row space-between"
                style={{ alignItems: "center", marginTop: "2rem" }}
              >
                <div>Overground Right</div>
                <div>{(112 - calculateAverage(rightWaveform)).toFixed(2)}</div>
              </div>
              <div
                className="row space-between"
                style={{ alignItems: "center", marginTop: "2rem" }}
              >
                <div>Treadmill Left</div>
                <div>{(115 - calculateAverage(leftWaveform)).toFixed(2)}</div>
              </div>
              <div
                className="row space-between"
                style={{ alignItems: "center", marginTop: "2rem" }}
              >
                <div>Treadmill Right</div>
                <div>{(115 - calculateAverage(rightWaveform)).toFixed(2)}</div>
              </div>
            </div>
            <div className=""></div>
          </>
        )}
        <div ref={otherMetrics} className="resultGrid">
          <div style={{ padding: "0 0.5rem 2rem 0.5rem" }} className="h2">
            Other Metrics
          </div>
          <div
            className="row space-between"
            style={{ alignItems: "center", marginTop: "2rem" }}
          >
            <div className="col centerAlign">
              <div>
                <img src={badAccuracy} alt="Accuracy score" />
              </div>
              <div className="h2">{accuracy}</div>
              <div className="b1">Accuracy</div>
              <div className="b2 textCenter">
                Proportion of on
                <br /> target steps
              </div>
            </div>
            <div className="col centerAlign">
              <div>
                <img src={stepCount} alt="Step Count" />
              </div>
              <div className="h2">{stepCounts}</div>
              <div className="b1">Step count</div>
              <div className="b2 textCenter">
                Total number
                <br /> of steps
              </div>
            </div>
            <div className="col centerAlign">
              <div>
                <img src={stepTime} alt="Step Time" />
              </div>
              <div className="h2">{avgStepTime} Sec</div>
              <div className="b1">Step-time</div>
              <div className="b2 textCenter">
                Time to
                <br /> complete a step
              </div>
            </div>
          </div>
        </div>
        <div className=""></div>
      </div>
    </div>
  );
};
export default SessionResult;
